import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CheckoutSummary from '../components/CheckoutSummary';
import CheckoutSummaryMobile from '../components/CheckoutSummaryMobile';

import MixedCoach from './GetCoaching/MixedCoaching';
import VodCoaching from './GetCoaching/VodCoaching';
import VersusCoaching from './GetCoaching/VersusCoaching';
import CopilotCoaching from './GetCoaching/CopilotCoaching';

import NewNavigation from '../components/NewNavigation';

export default function GetCoaching() {
    const { pathname } = useLocation();
    const containerRef = useRef(null)
    const [isOverflowing, setIsOverflowing] = useState(false)

    const [price, setPrice] = useState(null);
    const [orderDetails, setOrderDetails] = useState([]);
    const [loadTimer, setLoadTimer] = useState(false);
    const [checkoutTrigger, setCheckoutTrigger] = useState(false);
    const [discountedPrice, setDiscountedPrice] = useState(null);

    useEffect(() => {
        // Reset the checkout trigger when the component mounts
        if (checkoutTrigger) {
            setCheckoutTrigger(false);
        }
    }, [checkoutTrigger]);

        // 1) change your thumb state to track left + width:
        const [thumbStyle, setThumbStyle] = useState({ left: '0%', width: '0%'})
    
        // 2) in your useEffect, compute left + width in %:
        useEffect(() => {
        const el = containerRef.current
        if (!el) return
    
        const update = () => {
            const { scrollWidth, clientWidth, scrollLeft } = el
            const overflowing = scrollWidth > clientWidth
            setIsOverflowing(overflowing)
    
            if (overflowing) {
            const widthPct = (clientWidth / scrollWidth) * 100
            const offsetPct = (scrollLeft / (scrollWidth - clientWidth)) * (100 - widthPct)
            setThumbStyle({
                width: `${widthPct}%`,
                left:  `${offsetPct}%`,    // ← use left, not translateX
            })
            }
        }
    
        update()
        el.addEventListener('scroll', update)
        window.addEventListener('resize', update)
        return () => {
            el.removeEventListener('scroll', update)
            window.removeEventListener('resize', update)
        }
        }, [])

    return (
        <div className="w-full mt-8 p-6">
            <div className="mx-auto flex max-w-6xl flex-col gap-8 lg:flex-row">
                {/* Left Side: Main Form */}
                <div className="flex-1 space-y-8">
                  
                {/* Top Navbar */}
                <NewNavigation 
                paths={
                  [['Mixed Coaching', 'get-coaching/mixed'],
                  ['Co-Pilot', 'get-coaching/copilot'],
                  ['VOD Review', 'get-coaching/vod-review'],
                  ['Battle Games', 'get-coaching/versus']]
                }
                />

                {/* Main content */}
                {pathname.includes('mixed') && (
                    <MixedCoach 
                        updatePrice={setPrice} 
                        checkoutInit={checkoutTrigger} 
                        order_details={setOrderDetails} 
                        loading={setLoadTimer}
                    />
                )}
                
                {pathname.includes('vod-review') && (
                    <VodCoaching 
                        updatePrice={setPrice} 
                        checkoutInit={checkoutTrigger} 
                        order_details={setOrderDetails} 
                        loading={setLoadTimer}
                    />
                )}
                
                {pathname.includes('versus') && (
                    <VersusCoaching 
                        updatePrice={setPrice} 
                        checkoutInit={checkoutTrigger} 
                        order_details={setOrderDetails} 
                        loading={setLoadTimer}
                    />
                )}
                {pathname.includes('copilot') && (
                    <CopilotCoaching 
                        updatePrice={setPrice} 
                        checkoutInit={checkoutTrigger} 
                        order_details={setOrderDetails} 
                        loading={setLoadTimer}
                    />
                )}
                
                </div>

                {/* Right Side: Checkout Summary */}
                <CheckoutSummary
                    price={price}
                    order_details={orderDetails}
                    checkoutInit={setCheckoutTrigger}
                    loadTimer={loadTimer}
                    disableAddons={true}
                    discountedPrice={setDiscountedPrice}
                />
            </div>
            {/* Mobile Summary */}
            <CheckoutSummaryMobile price={discountedPrice || 0} targetId="checkout-summary" />
        </div>
    );
}
